export enum LessonCommentStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}